import { z } from 'zod';
export const saveKeywordBatchSchema = z.object({
    /**
     * Free text. Commas, semicolons, newlines and the word `OR` separate
     * keywords; "quoted phrases" stay whole. Parsed by parseKeywords.
     */
    raw: z.string().trim().min(1, 'Enter at least one keyword').max(8000),
    /**
     * Whether batches already running should keep running.
     *
     * Several batches can be active at once, so adding a set does not have to
     * retire the previous one — a user narrowing their filter usually wants the
     * old one off, while a user adding a second campaign usually wants both.
     */
    deactivateExisting: z.boolean().default(false),
});
export const setBatchActiveSchema = z.object({ isActive: z.boolean() });
const DATE_FMT = { day: 'numeric', month: 'short' };
/**
 * The display name for a batch.
 *
 * Derived from its dates rather than stored, because a stored label would go
 * stale the instant the batch was deactivated — and the two dates are already
 * the whole name:
 *
 *     still running   →  "From 16 Aug"
 *     stopped         →  "13 – 16 Aug 2026"
 *     started+stopped
 *       on one day    →  "16 Aug 2026"
 */
export function batchLabel(createdAt, deactivatedAt) {
    const from = new Date(createdAt);
    if (!deactivatedAt)
        return `From ${from.toLocaleDateString(undefined, DATE_FMT)}`;
    const to = new Date(deactivatedAt);
    const sameDay = from.toDateString() === to.toDateString();
    if (sameDay) {
        return from.toLocaleDateString(undefined, { ...DATE_FMT, year: 'numeric' });
    }
    return `${from.toLocaleDateString(undefined, DATE_FMT)} – ${to.toLocaleDateString(undefined, { ...DATE_FMT, year: 'numeric' })}`;
}
//# sourceMappingURL=keywordBatch.js.map